import { Styles } from 'shared/types';

export const AppTitleWrapper: Styles = {
  display: 'flex',
  alignItems: 'center',
  color: 'background.paper',
  textDecoration: 'none',
};
